module.exports = __webpack_public_path__ + "img/artwork-3.fcc88f42.png";